import React, { Component } from "react";
import { connect } from "react-redux";
import { TweenMax } from "gsap";
import { destroyExplosion } from "../actions/explosions.js";
import {ExplosionImg1, ExplosionImg2, ExplosionImg3} from './Images';
import sample from 'lodash/sample';

const mapStateToProps = state => {
    return{ clickSequence: state.clickSequence }
};
const mapDispatchToProps = dispatch => {
    return {
        destroyExplosion: id => dispatch(destroyExplosion(id))
    };
};

class ExplosionView extends Component {
    componentDidMount() {
        TweenMax.delayedCall(0.3, () => this.props.destroyExplosion(this.props.id) );
    }

    render() {
        const width = this.props.width;
        const height = this.props.height;
        const x = this.props.left - width / 2;
        const y = this.props.top - height / 2;

        const randomExplosion = sample([ExplosionImg1, ExplosionImg2, ExplosionImg3]);
        const multiplier = Math.floor( this.props.clickSequence / 10 ) + 1;
        const m = this.props.score;

        const explosionStyles = {
            width: `${width}px`,
            height: `${height}px`,
            top: `${y}px`,
            left: `${x}px`
        };
        
        const numberStyles = {
            "top": `${(height / 2) - 20}px`,
            "left": `${width / -4}px`
        };

        let n = '';

        if(multiplier > 1){
            n += "x";
            n += multiplier;
        }

        return (
            <div className="explosionOffset" style={explosionStyles}>
                <div className="explosionNumber" style={numberStyles}>
                    <span className="explosionNumberDigits">
                        <span>{m}</span>
                        <span className="explosionNumberMultiplier">{n}</span>
                    </span>
                    <span className="explosionNumberShadow">
                        <span>{m}</span>
                        { (multiplier > 1) &&
                            <span className="explosionMultiplierShadow"></span>
                        }
                    </span>
                </div>
                <img src={randomExplosion} alt='explosion'/>
            </div>
        );
    }
}

const Explosion = connect(mapStateToProps, mapDispatchToProps)(ExplosionView);
export default Explosion;



// WEBPACK FOOTER //
// ./src/components/Explosion.js